import { Insurance } from "../../../services/scheduleService/model/schedule/Insurance";
import { CompositeSpecification } from "../../../utils/Specification";

export class RequiresBcbsT2GAuth extends CompositeSpecification<Insurance> {
    IsSatisfiedBy(candidate: Insurance): boolean {
        return candidate.policy?.toUpperCase().startsWith('T2G') ?? false;
    }
}
